import React, {useState, useEffect} from 'react';
import {Outlet} from "react-router";
import styled from 'styled-components';

import { Sidebar } from "../../components/navigation";
import { breakpoints } from '../../styles/variables';
import { users } from '../../services/api'
import { organisations } from "../../services/api";

import {DataPageWrapper} from "./wrapper";


// ------------------------------
// ------------------------ styles
const Wrapper = styled.section`
  display: flex;
  height: 100vh;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
  background-attachment: fixed;

  @media (max-width: ${breakpoints.TABLET_SIZE}) {
    flex-direction: column;
    max-width: 100vw;
  }
`;

const Content = styled.section`
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;

  @media (min-width: ${breakpoints.TABLET_SIZE_PLUS_1}) {
    width: 0;
  }
`;

const PageContainer = styled.div`
    margin: 1rem;
    max-width: calc(100% - 2rem);
    overflow-x: auto;
`;


// ------------------------------
// ------------------------- page
const DataPage = () => {
    const [user, setUser] = useState();
    const [availableOrganisations, setAvailableOrganisations] = useState();

    // on componentDidMount
    useEffect(() => {
        users.profile().then(_user => {
            setUser(_user);
            return organisations.userHasMembership();
        }).then(_availableOrganisations  => {
            setAvailableOrganisations(_availableOrganisations);
        });
    }, [])

    return (
        <Wrapper className="logged-in">
            <Sidebar
                blur={0}
                user={user}
                availableOrganisations={availableOrganisations}
            />
            <Content>
                <DataPageWrapper>
                    <PageContainer>
                        <Outlet />
                    </PageContainer>
                </DataPageWrapper>
            </Content>
        </Wrapper>
    )
}

export { DataPage };
